/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, set } from '@ember/object';
import Component from '@glimmer/component';
import TransactionalMessageForm from 'cio/components/transactional/message-form';

interface TransactionalMessageFormFieldsArgs {
  messageAttrs: TransactionalMessageForm['messageAttrs'];
  validations: TransactionalMessageForm['validations'];
  readOnly: boolean;
  onAddTag: () => unknown;
  onRemoveTag: () => unknown;
}

export default class TransactionalMessageFormFields extends Component<TransactionalMessageFormFieldsArgs> {
  @action
  onNameChange(name: string) {
    set(this.args.messageAttrs, 'name', name);
    this.args.validations.validateAttribute('name');
  }
}
